var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSellingApartments({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 89.999,
    viewBox: "0 0 84 89.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10686",
    "data-name": "Group 10686",
    transform: "translate(-1610.961 -660.684)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10247",
    "data-name": "Path 10247",
    d: "M417.245,189.844A1.24,1.24,0,0,1,416,188.6V161.311a1.241,1.241,0,0,1,2.483,0V188.6A1.24,1.24,0,0,1,417.245,189.844Zm0,0",
    transform: "translate(1261.849 530.6)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10248",
    "data-name": "Path 10248",
    d: "M81.277,189.844a1.24,1.24,0,0,1-1.241-1.241V161.311a1.241,1.241,0,0,1,2.483,0V188.6A1.24,1.24,0,0,1,81.277,189.844Zm0,0",
    transform: "translate(1546.266 530.6)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10249",
    "data-name": "Path 10249",
    d: "M199.616,82.5h-22.34a1.241,1.241,0,0,1,0-2.483h22.34a1.241,1.241,0,1,1,0,2.483Zm0,0",
    transform: "translate(1464.872 598.684)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10250",
    "data-name": "Path 10250",
    d: "M199.616,450.491h-22.34a1.241,1.241,0,0,1,0-2.483h22.34a1.241,1.241,0,1,1,0,2.483Zm0,0",
    transform: "translate(1464.872 286.89)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_127",
    "data-name": "Ellipse 127",
    transform: "translate(1666.049 660.684)",
    fill: "#fff",
    stroke: "#00641f",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.456,
    cy: 14.456,
    rx: 14.456,
    ry: 14.456,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.456,
    cy: 14.456,
    rx: 13.956,
    ry: 13.956,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_128",
    "data-name": "Ellipse 128",
    transform: "translate(1610.961 660.684)",
    fill: "#fff",
    stroke: "#00641f",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.456,
    cy: 14.456,
    rx: 14.456,
    ry: 14.456,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.456,
    cy: 14.456,
    rx: 13.956,
    ry: 13.956,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_129",
    "data-name": "Ellipse 129",
    transform: "translate(1666.049 721.771)",
    fill: "#fff",
    stroke: "#00641f",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.456,
    cy: 14.456,
    rx: 14.456,
    ry: 14.456,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.456,
    cy: 14.456,
    rx: 13.956,
    ry: 13.956,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_130",
    "data-name": "Ellipse 130",
    transform: "translate(1610.961 721.771)",
    fill: "#fff",
    stroke: "#00641f",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.456,
    cy: 14.456,
    rx: 14.456,
    ry: 14.456,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.456,
    cy: 14.456,
    rx: 13.956,
    ry: 13.956,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Search_results_for_House_-_Flaticon-3",
    "data-name": "Search results for House - Flaticon-3",
    transform: "translate(1671.88 667.463)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10616",
    "data-name": "Group 10616",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10615",
    "data-name": "Group 10615"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10228",
    "data-name": "Path 10228",
    d: "M16.925,32.277l-3.147-2.771c0-.019.007-.038.011-.061V25.822a.4.4,0,0,0-.379-.4H11.653a.389.389,0,0,0-.368.4v1.5L8.768,25.109a.359.359,0,0,0-.478,0L.133,32.273a.387.387,0,0,0-.048.534.36.36,0,0,0,.518.049l.007-.008L8.529,25.9l2.834,2.49,1.695,1.486,3.393,2.979a.36.36,0,0,0,.518-.042A.391.391,0,0,0,16.925,32.277ZM13.05,28.866l-1.029-.895V26.186H13.05Z",
    transform: "translate(0.097 -24.92)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10228_-_Outline",
    "data-name": "Path 10228 - Outline",
    d: "M.215,32.89a.453.453,0,0,1-.357-.174.487.487,0,0,1,.061-.669l8.156-7.164a.465.465,0,0,1,.3-.115.454.454,0,0,1,.3.116l2.355,2.071V25.669a.488.488,0,0,1,.465-.5h1.761a.5.5,0,0,1,.473.494v3.649l3.105,2.734a.491.491,0,0,1,.056.669.457.457,0,0,1-.659.053l-3.393-2.979-1.695-1.486-2.77-2.434L.515,32.78A.469.469,0,0,1,.215,32.89Zm8.164-7.927a.269.269,0,0,0-.176.067L.045,32.2a.29.29,0,0,0-.034.4.259.259,0,0,0,.2.1.273.273,0,0,0,.171-.062L.4,32.624l7.982-7.009,2.9,2.547,1.695,1.486,3.393,2.98a.263.263,0,0,0,.174.067.266.266,0,0,0,.2-.1.293.293,0,0,0-.034-.4L13.52,29.39l.011-.055c0-.016.006-.032.009-.05V25.669a.3.3,0,0,0-.283-.3H11.5a.294.294,0,0,0-.27.3v1.717L8.552,25.03A.26.26,0,0,0,8.379,24.963ZM13,28.928l-1.225-1.064V25.936H13Zm-1.029-1.154.834.725V26.131h-.834Z",
    transform: "translate(0.248 -24.768)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10618",
    "data-name": "Group 10618",
    transform: "translate(1.675 2.176)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10617",
    "data-name": "Group 10617"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10229",
    "data-name": "Path 10229",
    d: "M57.786,88.037l-1.025-.874L51.3,82.505a.366.366,0,0,0-.474,0l-5.463,4.658-1.025.874a.363.363,0,0,0-.04.514.356.356,0,0,0,.5.044l0,0,.456-.393v6.829a.385.385,0,0,0,.376.375H56.484a.382.382,0,0,0,.376-.375V88.2l.456.393a.363.363,0,0,0,.234.087.369.369,0,0,0,.277-.127A.36.36,0,0,0,57.786,88.037Zm-5.265,6.632H49.6V90.736h2.919Zm.73,0V90.383a.363.363,0,0,0-.35-.375H49.222a.363.363,0,0,0-.35.375v4.286H45.989V87.575l5.072-4.312,5.072,4.312v7.094Z",
    transform: "translate(-44.111 -82.32)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10229_-_Outline",
    "data-name": "Path 10229 - Outline",
    d: "M50.91,82.168a.459.459,0,0,1,.3.111L57.7,87.811a.452.452,0,0,1,.162.312.458.458,0,0,1-.111.339.465.465,0,0,1-.351.161.459.459,0,0,1-.3-.11l-.3-.255v6.615a.479.479,0,0,1-.472.473H45.483a.485.485,0,0,1-.474-.471V88.259l-.3.258a.46.46,0,0,1-.751-.39.46.46,0,0,1,.161-.316l1.026-.874,5.463-4.658A.47.47,0,0,1,50.91,82.168Zm6.487,6.26a.273.273,0,0,0,.2-.094.264.264,0,0,0,.065-.2.259.259,0,0,0-.093-.179l-1.026-.875-5.463-4.658a.263.263,0,0,0-.172-.064.274.274,0,0,0-.176.064L44.247,87.96a.266.266,0,0,0-.029.375.258.258,0,0,0,.363.035l.006-.006.618-.533v7.042a.287.287,0,0,0,.28.277H56.331a.283.283,0,0,0,.278-.279v-7.04l.618.533A.265.265,0,0,0,57.4,88.428Zm-6.488-5.446,5.17,4.4v7.237H53V90.231a.266.266,0,0,0-.253-.277H49.07a.266.266,0,0,0-.253.277v4.384H45.739V87.377Zm4.974,4.485-4.974-4.229-4.974,4.229v6.951h2.687V90.231a.461.461,0,0,1,.448-.473h3.678a.461.461,0,0,1,.448.473v4.189h2.687Zm-6.532,3.018h3.115v4.129H49.352Zm2.919.2H49.547v3.738h2.724Z",
    transform: "translate(-43.958 -82.168)",
    fill: "#00641f"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Search_results_for_House_-_Flaticon-3-2",
    "data-name": "Search results for House - Flaticon-3",
    transform: "translate(1671.88 728.298)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10616-2",
    "data-name": "Group 10616",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10615-2",
    "data-name": "Group 10615"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10228-2",
    "data-name": "Path 10228",
    d: "M16.925,32.277l-3.147-2.771c0-.019.007-.038.011-.061V25.822a.4.4,0,0,0-.379-.4H11.653a.389.389,0,0,0-.368.4v1.5L8.768,25.109a.359.359,0,0,0-.478,0L.133,32.273a.387.387,0,0,0-.048.534.36.36,0,0,0,.518.049l.007-.008L8.529,25.9l2.834,2.49,1.695,1.486,3.393,2.979a.36.36,0,0,0,.518-.042A.391.391,0,0,0,16.925,32.277ZM13.05,28.866l-1.029-.895V26.186H13.05Z",
    transform: "translate(0.097 -24.92)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10228_-_Outline-2",
    "data-name": "Path 10228 - Outline",
    d: "M.215,32.89a.453.453,0,0,1-.357-.174.487.487,0,0,1,.061-.669l8.156-7.164a.465.465,0,0,1,.3-.115.454.454,0,0,1,.3.116l2.355,2.071V25.669a.488.488,0,0,1,.465-.5h1.761a.5.5,0,0,1,.473.494v3.649l3.105,2.734a.491.491,0,0,1,.056.669.457.457,0,0,1-.659.053l-3.393-2.979-1.695-1.486-2.77-2.434L.515,32.78A.469.469,0,0,1,.215,32.89Zm8.164-7.927a.269.269,0,0,0-.176.067L.045,32.2a.29.29,0,0,0-.034.4.259.259,0,0,0,.2.1.273.273,0,0,0,.171-.062L.4,32.624l7.982-7.009,2.9,2.547,1.695,1.486,3.393,2.98a.263.263,0,0,0,.174.067.266.266,0,0,0,.2-.1.293.293,0,0,0-.034-.4L13.52,29.39l.011-.055c0-.016.006-.032.009-.05V25.669a.3.3,0,0,0-.283-.3H11.5a.294.294,0,0,0-.27.3v1.717L8.552,25.03A.26.26,0,0,0,8.379,24.963ZM13,28.928l-1.225-1.064V25.936H13Zm-1.029-1.154.834.725V26.131h-.834Z",
    transform: "translate(0.248 -24.768)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10618-2",
    "data-name": "Group 10618",
    transform: "translate(1.675 2.176)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10617-2",
    "data-name": "Group 10617"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10229-2",
    "data-name": "Path 10229",
    d: "M57.786,88.037l-1.025-.874L51.3,82.505a.366.366,0,0,0-.474,0l-5.463,4.658-1.025.874a.363.363,0,0,0-.04.514.356.356,0,0,0,.5.044l0,0,.456-.393v6.829a.385.385,0,0,0,.376.375H56.484a.382.382,0,0,0,.376-.375V88.2l.456.393a.363.363,0,0,0,.234.087.369.369,0,0,0,.277-.127A.36.36,0,0,0,57.786,88.037Zm-5.265,6.632H49.6V90.736h2.919Zm.73,0V90.383a.363.363,0,0,0-.35-.375H49.222a.363.363,0,0,0-.35.375v4.286H45.989V87.575l5.072-4.312,5.072,4.312v7.094Z",
    transform: "translate(-44.111 -82.32)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10229_-_Outline-2",
    "data-name": "Path 10229 - Outline",
    d: "M50.91,82.168a.459.459,0,0,1,.3.111L57.7,87.811a.452.452,0,0,1,.162.312.458.458,0,0,1-.111.339.465.465,0,0,1-.351.161.459.459,0,0,1-.3-.11l-.3-.255v6.615a.479.479,0,0,1-.472.473H45.483a.485.485,0,0,1-.474-.471V88.259l-.3.258a.46.46,0,0,1-.751-.39.46.46,0,0,1,.161-.316l1.026-.874,5.463-4.658A.47.47,0,0,1,50.91,82.168Zm6.487,6.26a.273.273,0,0,0,.2-.094.264.264,0,0,0,.065-.2.259.259,0,0,0-.093-.179l-1.026-.875-5.463-4.658a.263.263,0,0,0-.172-.064.274.274,0,0,0-.176.064L44.247,87.96a.266.266,0,0,0-.029.375.258.258,0,0,0,.363.035l.006-.006.618-.533v7.042a.287.287,0,0,0,.28.277H56.331a.283.283,0,0,0,.278-.279v-7.04l.618.533A.265.265,0,0,0,57.4,88.428Zm-6.488-5.446,5.17,4.4v7.237H53V90.231a.266.266,0,0,0-.253-.277H49.07a.266.266,0,0,0-.253.277v4.384H45.739V87.377Zm4.974,4.485-4.974-4.229-4.974,4.229v6.951h2.687V90.231a.461.461,0,0,1,.448-.473h3.678a.461.461,0,0,1,.448.473v4.189h2.687Zm-6.532,3.018h3.115v4.129H49.352Zm2.919.2H49.547v3.738h2.724Z",
    transform: "translate(-43.958 -82.168)",
    fill: "#00641f"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Search_results_for_House_-_Flaticon-3-3",
    "data-name": "Search results for House - Flaticon-3",
    transform: "translate(1616.793 728.298)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10616-3",
    "data-name": "Group 10616",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10615-3",
    "data-name": "Group 10615"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10228-3",
    "data-name": "Path 10228",
    d: "M16.925,32.277l-3.147-2.771c0-.019.007-.038.011-.061V25.822a.4.4,0,0,0-.379-.4H11.653a.389.389,0,0,0-.368.4v1.5L8.768,25.109a.359.359,0,0,0-.478,0L.133,32.273a.387.387,0,0,0-.048.534.36.36,0,0,0,.518.049l.007-.008L8.529,25.9l2.834,2.49,1.695,1.486,3.393,2.979a.36.36,0,0,0,.518-.042A.391.391,0,0,0,16.925,32.277ZM13.05,28.866l-1.029-.895V26.186H13.05Z",
    transform: "translate(0.097 -24.92)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10228_-_Outline-3",
    "data-name": "Path 10228 - Outline",
    d: "M.215,32.89a.453.453,0,0,1-.357-.174.487.487,0,0,1,.061-.669l8.156-7.164a.465.465,0,0,1,.3-.115.454.454,0,0,1,.3.116l2.355,2.071V25.669a.488.488,0,0,1,.465-.5h1.761a.5.5,0,0,1,.473.494v3.649l3.105,2.734a.491.491,0,0,1,.056.669.457.457,0,0,1-.659.053l-3.393-2.979-1.695-1.486-2.77-2.434L.515,32.78A.469.469,0,0,1,.215,32.89Zm8.164-7.927a.269.269,0,0,0-.176.067L.045,32.2a.29.29,0,0,0-.034.4.259.259,0,0,0,.2.1.273.273,0,0,0,.171-.062L.4,32.624l7.982-7.009,2.9,2.547,1.695,1.486,3.393,2.98a.263.263,0,0,0,.174.067.266.266,0,0,0,.2-.1.293.293,0,0,0-.034-.4L13.52,29.39l.011-.055c0-.016.006-.032.009-.05V25.669a.3.3,0,0,0-.283-.3H11.5a.294.294,0,0,0-.27.3v1.717L8.552,25.03A.26.26,0,0,0,8.379,24.963ZM13,28.928l-1.225-1.064V25.936H13Zm-1.029-1.154.834.725V26.131h-.834Z",
    transform: "translate(0.248 -24.768)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10618-3",
    "data-name": "Group 10618",
    transform: "translate(1.675 2.176)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10617-3",
    "data-name": "Group 10617"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10229-3",
    "data-name": "Path 10229",
    d: "M57.786,88.037l-1.025-.874L51.3,82.505a.366.366,0,0,0-.474,0l-5.463,4.658-1.025.874a.363.363,0,0,0-.04.514.356.356,0,0,0,.5.044l0,0,.456-.393v6.829a.385.385,0,0,0,.376.375H56.484a.382.382,0,0,0,.376-.375V88.2l.456.393a.363.363,0,0,0,.234.087.369.369,0,0,0,.277-.127A.36.36,0,0,0,57.786,88.037Zm-5.265,6.632H49.6V90.736h2.919Zm.73,0V90.383a.363.363,0,0,0-.35-.375H49.222a.363.363,0,0,0-.35.375v4.286H45.989V87.575l5.072-4.312,5.072,4.312v7.094Z",
    transform: "translate(-44.111 -82.32)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10229_-_Outline-3",
    "data-name": "Path 10229 - Outline",
    d: "M50.91,82.168a.459.459,0,0,1,.3.111L57.7,87.811a.452.452,0,0,1,.162.312.458.458,0,0,1-.111.339.465.465,0,0,1-.351.161.459.459,0,0,1-.3-.11l-.3-.255v6.615a.479.479,0,0,1-.472.473H45.483a.485.485,0,0,1-.474-.471V88.259l-.3.258a.46.46,0,0,1-.751-.39.46.46,0,0,1,.161-.316l1.026-.874,5.463-4.658A.47.47,0,0,1,50.91,82.168Zm6.487,6.26a.273.273,0,0,0,.2-.094.264.264,0,0,0,.065-.2.259.259,0,0,0-.093-.179l-1.026-.875-5.463-4.658a.263.263,0,0,0-.172-.064.274.274,0,0,0-.176.064L44.247,87.96a.266.266,0,0,0-.029.375.258.258,0,0,0,.363.035l.006-.006.618-.533v7.042a.287.287,0,0,0,.28.277H56.331a.283.283,0,0,0,.278-.279v-7.04l.618.533A.265.265,0,0,0,57.4,88.428Zm-6.488-5.446,5.17,4.4v7.237H53V90.231a.266.266,0,0,0-.253-.277H49.07a.266.266,0,0,0-.253.277v4.384H45.739V87.377Zm4.974,4.485-4.974-4.229-4.974,4.229v6.951h2.687V90.231a.461.461,0,0,1,.448-.473h3.678a.461.461,0,0,1,.448.473v4.189h2.687Zm-6.532,3.018h3.115v4.129H49.352Zm2.919.2H49.547v3.738h2.724Z",
    transform: "translate(-43.958 -82.168)",
    fill: "#00641f"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Search_results_for_House_-_Flaticon-3-4",
    "data-name": "Search results for House - Flaticon-3",
    transform: "translate(1616.793 667.463)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10616-4",
    "data-name": "Group 10616",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10615-4",
    "data-name": "Group 10615"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10228-4",
    "data-name": "Path 10228",
    d: "M16.925,32.277l-3.147-2.771c0-.019.007-.038.011-.061V25.822a.4.4,0,0,0-.379-.4H11.653a.389.389,0,0,0-.368.4v1.5L8.768,25.109a.359.359,0,0,0-.478,0L.133,32.273a.387.387,0,0,0-.048.534.36.36,0,0,0,.518.049l.007-.008L8.529,25.9l2.834,2.49,1.695,1.486,3.393,2.979a.36.36,0,0,0,.518-.042A.391.391,0,0,0,16.925,32.277ZM13.05,28.866l-1.029-.895V26.186H13.05Z",
    transform: "translate(0.097 -24.92)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10228_-_Outline-4",
    "data-name": "Path 10228 - Outline",
    d: "M.215,32.89a.453.453,0,0,1-.357-.174.487.487,0,0,1,.061-.669l8.156-7.164a.465.465,0,0,1,.3-.115.454.454,0,0,1,.3.116l2.355,2.071V25.669a.488.488,0,0,1,.465-.5h1.761a.5.5,0,0,1,.473.494v3.649l3.105,2.734a.491.491,0,0,1,.056.669.457.457,0,0,1-.659.053l-3.393-2.979-1.695-1.486-2.77-2.434L.515,32.78A.469.469,0,0,1,.215,32.89Zm8.164-7.927a.269.269,0,0,0-.176.067L.045,32.2a.29.29,0,0,0-.034.4.259.259,0,0,0,.2.1.273.273,0,0,0,.171-.062L.4,32.624l7.982-7.009,2.9,2.547,1.695,1.486,3.393,2.98a.263.263,0,0,0,.174.067.266.266,0,0,0,.2-.1.293.293,0,0,0-.034-.4L13.52,29.39l.011-.055c0-.016.006-.032.009-.05V25.669a.3.3,0,0,0-.283-.3H11.5a.294.294,0,0,0-.27.3v1.717L8.552,25.03A.26.26,0,0,0,8.379,24.963ZM13,28.928l-1.225-1.064V25.936H13Zm-1.029-1.154.834.725V26.131h-.834Z",
    transform: "translate(0.248 -24.768)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10618-4",
    "data-name": "Group 10618",
    transform: "translate(1.675 2.176)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10617-4",
    "data-name": "Group 10617"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10229-4",
    "data-name": "Path 10229",
    d: "M57.786,88.037l-1.025-.874L51.3,82.505a.366.366,0,0,0-.474,0l-5.463,4.658-1.025.874a.363.363,0,0,0-.04.514.356.356,0,0,0,.5.044l0,0,.456-.393v6.829a.385.385,0,0,0,.376.375H56.484a.382.382,0,0,0,.376-.375V88.2l.456.393a.363.363,0,0,0,.234.087.369.369,0,0,0,.277-.127A.36.36,0,0,0,57.786,88.037Zm-5.265,6.632H49.6V90.736h2.919Zm.73,0V90.383a.363.363,0,0,0-.35-.375H49.222a.363.363,0,0,0-.35.375v4.286H45.989V87.575l5.072-4.312,5.072,4.312v7.094Z",
    transform: "translate(-44.111 -82.32)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10229_-_Outline-4",
    "data-name": "Path 10229 - Outline",
    d: "M50.91,82.168a.459.459,0,0,1,.3.111L57.7,87.811a.452.452,0,0,1,.162.312.458.458,0,0,1-.111.339.465.465,0,0,1-.351.161.459.459,0,0,1-.3-.11l-.3-.255v6.615a.479.479,0,0,1-.472.473H45.483a.485.485,0,0,1-.474-.471V88.259l-.3.258a.46.46,0,0,1-.751-.39.46.46,0,0,1,.161-.316l1.026-.874,5.463-4.658A.47.47,0,0,1,50.91,82.168Zm6.487,6.26a.273.273,0,0,0,.2-.094.264.264,0,0,0,.065-.2.259.259,0,0,0-.093-.179l-1.026-.875-5.463-4.658a.263.263,0,0,0-.172-.064.274.274,0,0,0-.176.064L44.247,87.96a.266.266,0,0,0-.029.375.258.258,0,0,0,.363.035l.006-.006.618-.533v7.042a.287.287,0,0,0,.28.277H56.331a.283.283,0,0,0,.278-.279v-7.04l.618.533A.265.265,0,0,0,57.4,88.428Zm-6.488-5.446,5.17,4.4v7.237H53V90.231a.266.266,0,0,0-.253-.277H49.07a.266.266,0,0,0-.253.277v4.384H45.739V87.377Zm4.974,4.485-4.974-4.229-4.974,4.229v6.951h2.687V90.231a.461.461,0,0,1,.448-.473h3.678a.461.461,0,0,1,.448.473v4.189h2.687Zm-6.532,3.018h3.115v4.129H49.352Zm2.919.2H49.547v3.738h2.724Z",
    transform: "translate(-43.958 -82.168)",
    fill: "#00641f"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10687",
    "data-name": "Group 10687",
    transform: "translate(1636.518 693.709)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10127",
    "data-name": "Path 10127",
    d: "M85.559,321.825l-1.159-.86a1.963,1.963,0,0,0-1.17-.4H81.484a3.377,3.377,0,0,0-1.058.169l-5.258,1.748A2.055,2.055,0,0,0,73.93,323.9l-4.625-3.1a1.517,1.517,0,0,0-1.238-.253,1.492,1.492,0,0,0-.46.187,2.013,2.013,0,0,0-.782.9,2.687,2.687,0,0,0-.241,1.122,2.379,2.379,0,0,0,.9,1.95l8.288,6.141a1.964,1.964,0,0,0,1.2.422h6.414a1.893,1.893,0,0,0,.837-.2l1.336-.653v.851h4.553V320H85.558Zm-1.67,8.2a1.143,1.143,0,0,1-.5.118H76.972a1.183,1.183,0,0,1-.725-.258l-8.3-6.148a1.194,1.194,0,0,1-.453-.979,1.362,1.362,0,0,1,.122-.564,1,1,0,0,1,.391-.447.747.747,0,0,1,.228-.091.778.778,0,0,1,.175-.02.764.764,0,0,1,.446.146l5.015,3.355c.006.034.006.068.013.1a1.938,1.938,0,0,0,1.76,1.669,3.7,3.7,0,0,0,.75-.166l4.73-1.567-.235-1.089-4.715,1.56c-.208.059-.475.127-.531.133a.965.965,0,0,1-.88-.83,1.256,1.256,0,0,1-.026-.209s0-.137,0-.184a1.105,1.105,0,0,1,.67-.994l5.255-1.741a2.611,2.611,0,0,1,.822-.134h1.745a1.174,1.174,0,0,1,.7.24l1.628,1.207v6.073Zm2.581-8.9H89.2v9.02H86.469Zm0,0",
    transform: "translate(-56.511 -303.213)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10128",
    "data-name": "Path 10128",
    d: "M20.2,4.448,17.568,1.465A4.13,4.13,0,0,0,14.452,0H8.3A2.228,2.228,0,0,0,7.2.293L6.1.917a1.308,1.308,0,0,1-.71.175l-.5-.02V0H0V12.231H4.9V10.563h.833l.3.222A4.969,4.969,0,0,0,8.814,11.8v7.1H29.379V4.448ZM3.917,11.119H.979V1.112H3.917Zm2.65-1.259-.545-.409H4.9V2.184l.462.019a2.216,2.216,0,0,0,1.184-.291l1.1-.623A1.33,1.33,0,0,1,8.3,1.112h6.156a3.213,3.213,0,0,1,2.424,1.14l1.934,2.2H14.77L13.581,3.1l-.692.786,3.459,3.928a1.225,1.225,0,0,1,0,1.577.9.9,0,0,1-1.389,0l-2.889-3.28-.343.334a2.361,2.361,0,0,1-3.3.055L8.146,6.24,7.529,7.1l.287.264a3.481,3.481,0,0,0,1,.638v2.687a4.068,4.068,0,0,1-2.246-.832Zm6.965-.52.739.839a1.81,1.81,0,0,0,2.766,0A3.064,3.064,0,0,0,17.682,14a2.285,2.285,0,0,0,3.389-.556,3.087,3.087,0,0,0-.335-3.869,2.272,2.272,0,0,0-3.419.2,2.445,2.445,0,0,0,.16-2h6.557a3.169,3.169,0,0,0,2.408,2.734v2.316a3.169,3.169,0,0,0-2.408,2.734H14.159a3.169,3.169,0,0,0-2.408-2.734V10.517A2.872,2.872,0,0,0,13.532,9.34Zm4.095,2.335A1.578,1.578,0,0,1,19.1,10.007a1.578,1.578,0,0,1,1.469,1.668A1.578,1.578,0,0,1,19.1,13.343,1.578,1.578,0,0,1,17.627,11.675ZM28.4,17.791H9.793V8.239A3.24,3.24,0,0,0,12,7.6l.835.949a1.89,1.89,0,0,1-1.57.9h-.49V13.9h.49a2.1,2.1,0,0,1,1.959,2.224v.556H24.972v-.556A2.1,2.1,0,0,1,26.931,13.9h.49V9.451h-.49a2.1,2.1,0,0,1-1.959-2.224V6.672H16.728L15.749,5.56H28.4Zm0,0",
    transform: "translate(0 0)",
    fill: "#00641f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSellingApartments);
export default __webpack_public_path__ + "static/media/sellingApartments.9467f0a007224878b8847887db3b1b41.svg";
export { ForwardRef as ReactComponent };